import { __ } from '@wordpress/i18n';
import { useBlockProps } from '@wordpress/block-editor';
import {VayuBlockAdvanceStyle} from '@vayu-blocks/advance-panel/style.js';
import { dimensions ,borderStyle, borderRadiusStyle } from "@vayu-blocks/global";
import { VayuBlocksDevice } from '@vayu-blocks/device-control';

export default function AdvanceSettings({ children, attributes,setAttributes ,clientId}) {
    const { mergedStyles, handleMouseEnter, handleMouseLeave, responsiveClasses, hoverAnimationClass } = VayuBlockAdvanceStyle(attributes);
    const view = VayuBlocksDevice();
    let bordercolor = '';
    let heightscrollbar ='';
    let backgroudscrollBox = '';
    let backgroudscroll = '';
    let scrolltop = '';
    let scrollheight = '';
    let scrollerheight = '';

    if(attributes.scrollbar){
        bordercolor = 'black';
        heightscrollbar = '10px';
        backgroudscrollBox = attributes.scrollBox;
        backgroudscroll = attributes.scroll;
        scrolltop = attributes.scrolltop;
        scrollheight = attributes.scrollheight;
        scrollerheight = attributes.scrollerheight;
    }

    let displaynavigation= 'flex';
    if(!attributes.navigation){
        displaynavigation='none';
    }

    let displayopacity  = 1;

    if(attributes.navigationtype==='hover'){
        displayopacity = 0
    }

    let displaypagination= attributes.paginationtop;
    if(!attributes.pagination){
        displaypagination=150;
    }

    let displaypaginationTablet= attributes.paginationtopTablet;
    if(!attributes.pagination){
        displaypaginationTablet=110;
    }

    let displaypaginationMobile= attributes.paginationtopMobile;
    if(!attributes.pagination){
        displaypaginationMobile=110;
    }

    let displaypaginationprogress= '';
    if(!attributes.pagination){
        displaypaginationprogress='none';
    }

    let displaypaginationprogressopacity= 1;
    if(attributes.progresshover){
        displaypaginationprogressopacity=0;
    }

    const stylearrow = (attributes) => {
        return {
            ...borderRadiusStyle(attributes.arrowborderradius, view),  
             padding: dimensions(attributes.arrowpadding, view),
             ...borderStyle(attributes.arrowborder,view),
        }
    }
    const arrowStyles = stylearrow(attributes);

    const styleiconarrrow = (side) => {
        if (attributes.selectedFoldIcon === 'none') {
            return side === 'left' ? "'prev'" : "'next'";
        }

        const arrowMap = {
        'type-1': { left: '←', right: '→' },
        'type-2': { left: '⇦', right: '⇨' },
        'type-3': { left: '⇐', right: '⇒' },
        'type-4': { left: '⟵', right: '⟶' },
        'type-5': { left: '🡐', right: '🡒' },
        'type-6': { left: '🡄', right: '🡆' },
        'type-7': { left: '⇜', right: '⇝' },
        'type-8': { left: '⇠', right: '⇢' },
        'type-9': { left: '➤', right: '➥' },
        'type-10': { left: '🡸', right: '🡺' },
        'type-11': { left: '⏴', right: '⏵' },
        'type-12': { left: '⮜', right: '⮞' },
        'type-13': { left: '↚', right: '↛' },
        'type-14': { left: '⇷', right: '⇸' },
        'type-15': { left: '🢐', right: '🢒' },
        'type-16': { left: '🢔', right: '🢖' },
        'type-17': { left: '🢘', right: '🢚' },
        'type-18': { left: '⇚', right: '⇛' },
        };

        const selected = attributes.selectedFoldIcon;
        const arrow = arrowMap[selected];
        if (arrow) {
            const val = side === 'left' ? arrow.left : arrow.right;
            return `'${val}'`; // 👈 wrap in single quotes for CSS compatibility
        }

        return "'none'";
    };


    const blockProps = useBlockProps({
        className: `block-${clientId} ${hoverAnimationClass} ${responsiveClasses}`,
        style: {
            ...mergedStyles,
            '--vb-arrow-type-left': styleiconarrrow('left'),
            '--vb-arrow-type-right': styleiconarrrow('right'),

            '--vb-dots-alignment-Desktop': attributes.dotsalignment?.Desktop,
            '--vb-dots-alignment-Tablet': attributes.dotsalignment?.Tablet,
            '--vb-dots-alignment-Mobile': attributes.dotsalignment?.Mobile,
            '--vb-dots-height-Desktop': attributes.dotsheight?.Desktop || '0px',
            '--vb-dots-height-Tablet': attributes.dotsheight?.Tablet || '0px',
            '--vb-dots-height-Mobile': attributes.dotsheight?.Mobile || '0px',
            '--vb-dots-background':attributes.dotsbackground,
           '--vb-dots-size-Desktop': attributes.dotstype === 'progressbar'
                ? `${attributes.progresssize ?? 0}px`
                : attributes.bulletsize
                ? `${attributes.bulletsize}px`
                : undefined,

            '--vb-dots-size-Tablet': attributes.dotstype === 'progressbar'
                ? `${attributes.progresssizeTablet ?? 0}px`
                : attributes.bulletsizeTablet
                ? `${attributes.bulletsizeTablet}px`
                : undefined,

            '--vb-dots-size-Mobile': attributes.dotstype === 'progressbar'
                ? `${attributes.progresssizeMobile ?? 0}px`
                : attributes.bulletsizeMobile
                ? `${attributes.bulletsizeMobile}px`
                : undefined,

            '--vb-visible-dots': attributes.pagination ? 'flex' : 'none',

            '--scroll-opacity': attributes.scrolltype === 'hover' ? 0 : 1,
            '--scroll-top-Desktop':attributes.scrolltop?.Desktop,
            '--scroll-top-Tablet':attributes.scrolltop?.Tablet,
            '--scroll-top-Mobile':attributes.scrolltop?.Mobile,

            '--vb-padding': arrowStyles?.padding,
            '--vb-border': arrowStyles?.border,
            '--vb-radius-tl': arrowStyles?.borderTopLeftRadius,
            '--vb-radius-tr': arrowStyles?.borderTopRightRadius,
            '--vb-radius-bl': arrowStyles?.borderBottomLeftRadius,
            '--vb-radius-br': arrowStyles?.borderBottomRightRadius,

            '--swiper-scrollbar-color': bordercolor,
            '--swiper-scrollbar-height': heightscrollbar,
            '--swiper-scrollbar-backgroundbox': backgroudscrollBox,
            '--swiper-scrollbar-background': backgroudscroll,
            '--swiper-scrollbar-height-new':  `${scrollheight}px`,
            '--swiper-scrollerbar-height-new':  `${scrollheight}px`,
            '--swiper-navigation-display':displaynavigation,
            '--swiper-navigation-background': attributes.navigationbackground,
            '--swiper-navigation-color': attributes.navigationcolor,
            '--swiper-navigation-size':`${attributes.navigationsize}px`,
            '--swiper-navigation-sizeTablet':`${attributes.navigationsizeTablet}px`,
            '--swiper-navigation-sizeMobile':`${attributes.navigationsizeMobile}px`,
            '--swiper-navigation-navigationtop':`${attributes.navigationtop}%`,
            '--swiper-navigation-navigationtopTablet':`${attributes.navigationtopTablet}%`,
            '--swiper-navigation-navigationtopMobile':`${attributes.navigationtopMobile}%`,
            '--swiper-navigation-rightarrow':`${attributes.rightarrow}px`,
            '--swiper-navigation-rightarrowTablet':`${attributes.rightarrowTablet}px`,
            '--swiper-navigation-rightarrowMobile':`${attributes.rightarrowMobile}px`,
            '--swiper-navigation-opacity': displayopacity,
            '--swiper-pagination-color': attributes.paginationbackground,
            '--swiper-pagination-bullet-inactive-color': attributes.paginationinactivebackground,
            '--swiper-pagination-bullet-inactive-opacity' : 1,
            '--swiper-pagination-top':`${displaypagination}%`,
            '--swiper-pagination-topTablet':`${displaypaginationTablet}%`,
            '--swiper-pagination-topMobile':`${displaypaginationMobile}%`,
            '--swiper-pagination-bullet-width':`${attributes.bulletsize}px`,
            '--swiper-pagination-bullet-height':`${attributes.bulletsize}px`,
            '--swiper-pagination-bullet-widthTablet':`${attributes.bulletsizeTablet}px`,
            '--swiper-pagination-bullet-heightTablet':`${attributes.bulletsizeTablet}px`,
            '--swiper-pagination-bullet-widthMobile':`${attributes.bulletsizeMobile}px`,
            '--swiper-pagination-bullet-heightMobile':`${attributes.bulletsizeMobile}px`,
            '--swiper-pagination-fraction-color': attributes.numberscolor,
            '--swiper-pagination-dots-place': `${attributes.dotsplace}%`, 
            '--swiper-pagination-dots-placeTablet': `${attributes.dotsplaceTablet+100}%`, 
            '--swiper-pagination-dots-placeMobile': `${attributes.dotsplaceMobile+100}%`, 
            '--swiper-pagination-color-progress': attributes.progresscolor,
            '--swiper-pagination-opacity-progress': displaypaginationprogress,
            '--swiper-pagination-opacity-progress-bar': displaypaginationprogressopacity,
            '--swiper-pagination-progress-bar-size' :`${attributes.progresssize}px`,
            '--swiper-pagination-progress-bar-size-tablet' :`${attributes.progresssizeTablet}px`,
            '--swiper-pagination-progress-bar-size-mobile' :`${attributes.progresssizeMobile}px`,
        },

        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
    });

    if(attributes.classNamemain !== blockProps.className) {
        setAttributes({classNamemain: blockProps.className});
    }

    return (
        <div {...blockProps}>
            {children}
        </div>
    );
}

